import Image from 'next/image';
import { cn } from '@/libs/tailwind';

export function HandshakeAILogo({ className, size = 30 }: { className?: string; size?: number }) {
  return (
    <Image
      src="/assets/images/handshake_logo_neon.svg"
      alt="Handshake AI Logo"
      width={size || 30}
      height={size || 30}
      className={cn('text-[#1F202C]', className)}
    />
  );
}
